import { useAuthStore } from '@/store/auth.store';
import { AuthProviderProps } from 'react-oidc-context';

const oidcConfig: AuthProviderProps = {
    client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
    redirect_uri: window.location.origin,
    authority: import.meta.env.VITE_OIDC_AUTHORITY,
    client_secret: import.meta.env.VITE_OIDC_CLIENT_SECRET,
    scope: 'openid profile email roles',

    post_logout_redirect_uri: window.location.origin,
    onSigninCallback: (user) => {
        if (user?.access_token) useAuthStore.getState().setAuthToken(user.access_token);
    },
};

export default oidcConfig;
